export default "__VITE_ASSET__9E3Lz2Du__"